export const classes = {
  wrapper: 'flex gap-1 rounded-full bg-black/5 p-1 dark:bg-white/5',
  option:
    'place-center flex-1 gap-1.5 rounded-full px-3 py-1.5 text-sm font-medium text-taupe-2 hover:text-taupe-3 dark:text-mauve-2 dark:hover:text-mauve-1',
  active:
    'bg-grad text-white dark:text-white shadow-orange hover:text-white dark:bg-grad-dark',
};
